import CryptoJS from 'crypto-js';

/*
 * Wraps the checkout body in AES-256-CBC + HMAC-SHA256 before it goes on the
 * wire, so the request is not trivially editable from devtools or a proxy.
 *
 * This is obfuscation, NOT a security boundary: the key below ships inside the
 * JS bundle and anyone determined can read it. Payout integrity is enforced
 * server side in OrderRepo::saveOrder, which recomputes grand_total and the
 * commission from the DB and ignores the amount/commission/total sent here.
 * Do not weaken those checks on the strength of this file.
 *
 * Wire format posted to /api/v2/cms/checkout:
 *   { v: 1, iv: <base64>, p: <base64 ciphertext>, s: <hex hmac> }
 * The HMAC covers "<iv>.<p>" so a tampered body fails before decryption.
 */

export function sealCheckout(formdata) {
    // Read lazily (not at module load): App.js requires ./BPdata.js after
    // importing the page components that pull in this module, so window.BPdata
    // does not exist yet when this file is first evaluated.
    // Must match CHECKOUT_PAYLOAD_KEY in the dashboard .env (64 hex chars = 32 bytes).
    const key = CryptoJS.enc.Hex.parse(window.BPdata.checkoutKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    // _ts and _n let the server reject stale bodies and replays of a captured one.
    const body = Object.assign({}, formdata, {
        _ts: Date.now(),
        _n: CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex),
    });

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(body), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    const ivB64 = iv.toString(CryptoJS.enc.Base64);
    const pB64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    return {
        v: 1,
        iv: ivB64,
        p: pB64,
        s: CryptoJS.HmacSHA256(ivB64 + '.' + pB64, key).toString(CryptoJS.enc.Hex),
    };
}

export default sealCheckout;
